// import { apiUrlStatistics } from "~constants";
// import Network from "~helpers/Network";

import { apiUrlStatisticGenerator, apiUrlStatisticsFigures } from "~constants";
import Network from "~helpers/Network";

import * as at from "./actionTypes";

export const setFigureFilter = (payload) => ({
  type: at.SET_FIGURE_FILTER,
  payload,
});

export const setHideBlanks = (payload) => ({
  type: at.SET_HIDE_BLANKS,
  payload,
});

export const setFigureSortInfo = (payload) => ({
  type: at.SET_FIGURE_SORT_INFO,
  payload,
});

// export const getStatisticFigure = (projectId, id) => (_dispatch, _getState) => {
//   const url = `${apiUrlStatisticsFigures.getFigure.format(projectId, id)}`;
//   return Network.request(url, {
//     loading: true,
//     onSuccess: setStatisticFigure,
//   });
// };

// export const createOrUpdateStatisticFigure =
//   (projectId, data, options = {}) =>
//   (_dispatch, _getState) => {
//     const url = `${data?.id ? apiUrlStatisticsFigures.getFigure.format(projectId, data.id) : apiUrlStatisticsFigures.get.format(projectId)}`;
//     return Network.request(url, {
//       method: data?.id ? "PATCH" : "POST",
//       data,
//       loading: true,
//       successMsg: true,
//       ...options,
//     });
//   };

export const callStatisticFigure =
  (projectId, figureId, filters = {}, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlStatisticGenerator.callFigure.format(projectId, figureId)}`;
    return Network.request(url, {
      method: "POST",
      loading: true,
      data: {
        filters,
      },
      ...options,
    });
  };

export const generateFigureSync =
  (projectId, figureId, data, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlStatisticsFigures.generateSync.format(projectId, figureId)}`;
    return Network.request(url, {
      method: "POST",
      loading: true,
      data,
      ...options,
    });
  };

export const downloadFigureExcel =
  (projectId, figure_data = {}, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlStatisticsFigures.downloadExcel.format(projectId)}`;
    return Network.request(url, {
      method: "POST",
      responseType: "blob",
      loading: true,
      data: {
        figure_data,
      },
      ...options,
    });
  };
